import { networkAffiliatePreferenceTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

export const networkAffiliatePreferenceCreate = (state = defaultState, action) =>
  commonReducer(actionTypes.CREATE, state, action);
